export default __webpack_public_path__ + "static/search-start-page-decoration-97521d56c1f9203e354e34c8910070b6.svg";